import { stringify } from 'qs';

import { IApplicationState, TThunkAction } from '../../types/redux';
import { selectPreciseFiltersState } from '../../selectors/preciseFilters';
import { selectDealType, selectEstimationId, selectMyHomeId } from '../../selectors/page';
import { DEFAULT_DOCUMENT_TITLE, FLAT_PATH, SUBURBAN_PATH } from '../../constants/page';
import { setQueryParams } from './actions';
import { IParsedQsParams } from '../../types/expectedQsParams';
import { isBrowser } from '../../utils/isBrowser';
import { EPageType } from '../../types/redux/page';

export const updateUrl = (): TThunkAction => (dispatch, getState) => {
  const state = getState();
  const isSuburbanPage = state.page.pageType === EPageType.CalculatorSuburban;

  const queryParams = collectQueryParams(state);
  // Удаляем не нужные параметры для загородки, чтобы они не фигурировали в урле
  // oxlint-disable-next-line typescript/no-unused-vars
  const { totalArea, roomsCount, floor, ...suburbanQueryParams } = queryParams;

  dispatch(setQueryParams(queryParams));

  const pathname = isSuburbanPage ? SUBURBAN_PATH : FLAT_PATH;
  const _queryParams = isSuburbanPage ? suburbanQueryParams : queryParams;

  if (isBrowser()) {
    setBrowserQueryParams(_queryParams, pathname);
  }
};

function setBrowserQueryParams(queryParams: object, pathname: string) {
  const { protocol, host } = window.location;
  const qs = stringify(queryParams, { addQueryPrefix: true, skipNulls: true });
  const url = `${protocol}//${host}${pathname}${qs}`;

  window.history.pushState('', DEFAULT_DOCUMENT_TITLE, url);
}

function collectQueryParams(state: IApplicationState): IParsedQsParams {
  const preciseFiltersState = selectPreciseFiltersState(state);
  const dealType = selectDealType(state);
  const estimationId = selectEstimationId(state);
  const myHomeId = selectMyHomeId(state);

  return {
    address: state.filters.address,
    totalArea: state.filters.area as number,
    roomsCount: state.filters.roomsCount as number,
    valuationType: dealType,
    estimationId: estimationId || undefined,
    myHome: myHomeId || undefined,
    landArea: state.filters.landArea,
    houseArea: state.filters.houseArea,
    category: state.filters.category,
    lat: state.page.queryParams.lat,
    lng: state.page.queryParams.lng,
    ...preciseFiltersState,
  };
}
